import { render } from "./AddMatiereModal.vue?vue&type=template&id=b80fcdf6&ts=true"
import script from "./AddMatiereModal.vue?vue&type=script&lang=ts"
export * from "./AddMatiereModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__